import * as React from 'react';

import { CardContent, CardContentProps } from '@mui/material';

export interface ContentProps extends CardContentProps {
  children: React.ReactNode;
  pb2?: boolean;
}

export const Content: React.FC<ContentProps> = ({ children, pb2, ...props }) => {
  return (
    <CardContent
      {...props}
      sx={{
        '&.MuiCardContent-root:last-child': { pb: pb2 ? 2 : 0 },
        ...props.sx,
      }}
    >
      {children}
    </CardContent>
  );
};
